import React from 'react';
import { RiFileDownloadFill } from "react-icons/ri";
import "./Component.css";
var FileSaver = require('file-saver');

const DownloadIcon = (props) => {

    let data = "";
    let cssId = props.cssId;
    if (props.isNull == 1) cssId = 'CantDownload';

    // console.log(cssId);

    const getData = async (callback) => {
        const response = await fetch(props.url);
        const body = await response.json();
        if (response.status !== 200){
            throw Error(body.message);
        } 
        data=JSON.stringify(body,null,4);
        callback(); 
    };

    const downloadFiles =() => {
        var content=data;
        var filename = "downloadFile.json";
        var blob = new Blob([content], {
        type: "application/json;charset=utf-8"
        });
        FileSaver.saveAs(blob, filename);
    };
    


    const onclick=()=>{
        getData(downloadFiles);        
    };

    
    return (
        <RiFileDownloadFill onClick={onclick} size="2em" className={cssId} />
    )
}

export default DownloadIcon
